import { View } from 'react-native'
import Page from '@shell/Page'
import Typography from '@ui/typography'

export default function DevTypographyPage() {
  return (
    <Page stage="dev">
      <View className="gap-8 p-16">
        <Typography variant={'H1'}>Headline 1</Typography>
        <Typography variant={'H2'}>Headline 2</Typography>
        <Typography variant={'H3'}>Headline 3</Typography>
        <Typography variant={'H4'}>Headline 4</Typography>
        <Typography variant={'H5'}>Headline 5</Typography>
        <Typography variant={'H6'}>Headline 6</Typography>
        <Typography variant={'XL'}>Extra Large Paragraph</Typography>
        <Typography variant={'XLB'}>Extra Large Paragraph Bold</Typography>
        <Typography variant={'LG'}>Large Paragraph</Typography>
        <Typography variant={'LGB'}>Large Paragraph Bold</Typography>
        <Typography variant={'MD'}>Medium Paragraph</Typography>
        <Typography variant={'MDB'}>Medium Paragraph Bold</Typography>
        <Typography variant={'SM'}>Small Paragraph</Typography>
        <Typography variant={'SMB'}>Small Paragraph Bold</Typography>
        <Typography variant={'XS'}>Extra Small Paragraph</Typography>
        <Typography variant={'XSB'}>Extra Small Paragraph Bold</Typography>
      </View>
    </Page>
  )
}
